import { LabelsOverviewPage } from "@/pages/labels-overview/ui/labels-overview-page";
import { createFileRoute } from "@tanstack/react-router";

const LabelsOverviewRoute = () => {
  return <LabelsOverviewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/labels",
)({
  component: LabelsOverviewRoute,
});
